import { useSectionColor } from '@/hooks/useSectionColor';
import { getSectionColor } from '@/lib/sectionColor';
import { hubColorForSection, type HubColor } from '@/components/Hub/hubIconAssets';

/** The Hub icon's color for a path. Exported for tests. Components want the hook below. */
export const getHubColorForPath = (pathname: string): HubColor =>
    hubColorForSection(getSectionColor(pathname));

/** The Hub icon's color for the current route. */
export const useHubContextColor = (): HubColor => hubColorForSection(useSectionColor());
